module.exports = __webpack_public_path__ + "static/media/leo-logo.1227e65b.png";